import { render } from "./MultisendBusked.vue?vue&type=template&id=e9ed8942"
import script from "./MultisendBusked.vue?vue&type=script&lang=js"
export * from "./MultisendBusked.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__